(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const toast = html => { const t = $('#toast'); if (!t) return; t.innerHTML = html; t.hidden = false; clearTimeout(t._t); t._t = setTimeout(() => t.hidden = true, 4000); };
  const setCount = n => $$('[data-cart-count]').forEach(e => { e.textContent = n; e.hidden = !n; });
  const showMedia = id => {
    $$('[data-media]').forEach(m => m.classList.toggle('is-active', m.dataset.media === String(id)));
    $$('[data-thumb]').forEach(t => t.toggleAttribute('aria-current', t.dataset.thumb === String(id)));
  };

  document.addEventListener('click', e => {
    const drawer = $('#menu-drawer'), bar = $('#searchbar');
    if (e.target.closest('[data-open-drawer]')) drawer.classList.add('open');
    if (e.target.closest('[data-close-drawer]')) drawer.classList.remove('open');
    if (e.target.closest('[data-toggle-search]')) { bar.classList.toggle('open'); if (bar.classList.contains('open')) $('input', bar).focus(); }
    const q = e.target.closest('[data-qty]');
    if (q) { const i = $('input', q.parentNode); i.value = Math.max(+i.min || 0, (+i.value || 0) + (+q.dataset.qty)); i.dispatchEvent(new Event('change', { bubbles: true })); }
    const th = e.target.closest('[data-thumb]'); if (th) showMedia(th.dataset.thumb);
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { $('#menu-drawer')?.classList.remove('open'); $('#searchbar')?.classList.remove('open'); } });

  // Ajax add to cart
  document.addEventListener('submit', e => {
    const f = e.target.closest('form[data-ajax-cart]'); if (!f) return;
    e.preventDefault();
    const b = $('[type=submit]', f); if (b) b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(d => {
        if (d.status) { toast(d.description || d.message); return; }
        fetch('/cart.js').then(r => r.json()).then(c => setCount(c.item_count));
        toast('Added to cart · <a href="/cart">View cart</a>');
      })
      .catch(() => f.submit())
      .finally(() => { if (b) b.disabled = false; });
  });

  // Cart page: update on quantity change
  $$('[data-cart-form]').forEach(f => f.addEventListener('change', () => f.submit()));

  // Collection filters
  $$('form[data-filters]').forEach(f => {
    f.addEventListener('change', () => f.submit());
    if (innerWidth < 990) { const w = $('.fwrap', f); if (w) w.open = false; }
  });

  // Variant picker
  $$('[data-product]').forEach(root => {
    const data = $('[data-variants]', root); if (!data) return;
    const variants = JSON.parse(data.textContent), idInput = $('input[name=id]', root);
    root.addEventListener('change', e => {
      if (!e.target.closest('[data-options]')) return;
      const sel = $$('[data-options] fieldset', root).map(fs => ($('input:checked', fs) || {}).value);
      const v = variants.find(v => v.options.every((o, i) => o === sel[i]));
      const atc = $('[data-atc] .btn', root);
      if (!v) { atc.disabled = true; atc.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      if (v.featured_media) showMedia(v.featured_media.id);
      history.replaceState({}, '', `${location.pathname}?variant=${v.id}`);
      fetch(`${location.pathname}?variant=${v.id}&section_id=${root.dataset.section}`)
        .then(r => r.text()).then(h => {
          const d = new DOMParser().parseFromString(h, 'text/html');
          ['[data-price]', '[data-atc]'].forEach(s => { const n = $(s, d), o = $(s, root); if (n && o) o.replaceWith(n); });
        });
    });
  });
})();
